import { History } from 'history';
import { BookingFlowStep } from './constants';
import { goToStep } from './goToStep';
import { nextServiceIds, readPickedIds } from './urlState';

export type AppendPickedServiceOptions = {
  /**
   * The hydrated pre-click selection (`book.services`), the same source the modal reads —
   * so the tracked `service_ids` matches the control arm's shape.
   */
  hydratedServices: readonly { id?: number | null }[] | undefined;
  /** The funnel event for this pick, given the full post-pick `service_ids`. */
  track: (serviceIds: string[]) => void;
};

/**
 * Appends a service to the selection on a step page: add-ons go into `rs`, main services
 * into `ss`, and the flow stays on `step`. Reads the URL live rather than the render-scoped
 * one — a repeat tap before hydration re-renders must not append or report the id again —
 * and tracks before the push so the session still names the step it happened on. The
 * live URL also covers a pick hydration has not caught up with yet (see nextServiceIds).
 */
export function appendPickedService(
  history: Pick<History, 'push' | 'replace' | 'location'>,
  placeSlugId: string,
  step: BookingFlowStep,
  field: 'ss' | 'rs',
  serviceId: number,
  { hydratedServices, track }: AppendPickedServiceOptions,
): void {
  const { addOnIds, mainServiceIds } = readPickedIds(history.location.search);
  const picked = field === 'rs' ? addOnIds : mainServiceIds;
  const id = String(serviceId);
  if (picked.includes(id)) return;
  track(nextServiceIds(hydratedServices, history.location.search, serviceId));
  const joined = [...picked, id].join(',');
  goToStep(history, placeSlugId, { type: 'step', step }, field === 'rs' ? { rs: joined } : { ss: joined });
}
